<i18n>
{
  "fr": {
    "form-list-title": "Liste des contacts",
    "id-label": "N°",
    "companyname-label": "Nom de l'entreprise",
    "address-label": "Adresse",
    "zip-label": "Npa",
    "city-label": "Ville",
    "firstname-label": "Prénom",
    "lastname-label": "Nom",
    "phone-label": "Numéro de téléphone",
    "email-label": "Adresse email",
    "create-label": "Date de création",
    "last-update-label": "Dernière modification",
    "actions-label": "Actions",
    "dialog-delete-confirm-title": "Supprimer",
    "dialog-delete-confirm-content": "Êtes-vous sûr de vouloir supprimer cet élément ?",
    "dialog-delete-confirm-button": "Oui",
    "dialog-delete-cancel-button": "Annuler",
    "create": "Créer"
  },
  "de": {
    "form-list-title": "Kontaktverwaltung",
    "id-label": "Nr.",
    "companyname-label": "Firma",
    "address-label": "Adresse",
    "zip-label": "PLZ",
    "city-label": "Stadt",
    "firstname-label": "Vorname",
    "lastname-label": "Name",
    "phone-label": "Telefonnummer",
    "email-label": "E-Mail",
    "create-label": "Erstellungsdatum",
    "last-update-label": "Letzte Änderung",
    "actions-label": "Handeln",
    "dialog-delete-confirm-title": "Löschen",
    "dialog-delete-confirm-content": "Möchten Sie diesen Artikel wirklich löschen?",
    "dialog-delete-confirm-button": "Ja",
    "dialog-delete-cancel-button": "Abbrechen",
    "create": "Estellen"
  }
}
</i18n>

<template>
  <div id="collect-data-gw" class="geo-forms">

    <Header :title="$t('form-list-title')" />

    <md-content class="md-elevation-3 main-container">

      <md-table v-model="contacts" md-card md-sort="companyName" @md-selected="onContactSelect" md-fixed-header>
        <md-table-toolbar>
          <md-button @click="createContact"><md-icon>add_circle_outline</md-icon> {{ $t('create') }}</md-button>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
          <md-table-cell :md-label="$t('id-label')" md-sort-by="id">{{ item.id }}</md-table-cell>
          <md-table-cell :md-label="$t('companyname-label')" md-sort-by="companyName">{{ item.companyName }}</md-table-cell>
          <md-table-cell :md-label="$t('address-label')" md-sort-by="address">{{ item.address }}</md-table-cell>
          <md-table-cell :md-label="$t('zip-label')" md-sort-by="zip">{{ item.zip }}</md-table-cell>
          <md-table-cell :md-label="$t('city-label')" md-sort-by="city">{{ item.city }}</md-table-cell>
          <md-table-cell :md-label="$t('firstname-label')" md-sort-by="firstName">{{ item.firstName }}</md-table-cell>
          <md-table-cell :md-label="$t('lastname-label')" md-sort-by="lastName">{{ item.lastName }}</md-table-cell>
          <md-table-cell :md-label="$t('actions-label')"><md-button @click.stop.native="showDialogDelete = true; itemToDelete = item"><md-icon>delete_forever</md-icon></md-button></md-table-cell>
        </md-table-row>
      </md-table>

    </md-content>

    <md-dialog-confirm
      :md-active.sync="showDialogDelete"
      :md-title="$t('dialog-delete-confirm-title')"
      :md-content="$t('dialog-delete-confirm-content')"
      :md-confirm-text="$t('dialog-delete-confirm-button')"
      :md-cancel-text="$t('dialog-delete-cancel-button')"
      @md-cancel="showDialogDelete = false; itemToDelete = null"
      @md-confirm="onDeleteConfirm"
    />

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import Vue from 'vue'
import Contact from '@/models/default/Contact'

import Header from '@/components/header'
import Snackbar from '@/components/snackbar'

export default {
  name: 'ListForms',
  components: {
    Header,
    Snackbar
  },
  data () {
    return {
      contacts: [],
      showDialogDelete: false,
      itemToDelete: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadData().then(() => {

      }).catch(this.handleError)
    })
  },
  methods: {
    loadData () {
      return new Promise((resolve, reject) => {
        let toFetch = []
        toFetch.push(Contact.list())

        Promise.all(toFetch).then((data) => {
          this.contacts = data[0]
          resolve()
        }).catch(reject)
      })
    },
    onContactSelect (contact) {
      this.$router.push({
        name: 'detail-contact',
        params: { id: contact.id }
      })
    },
    createContact () {
      this.$router.push({
        name: 'new-contact'
      })
    },
    deleteContact (contact) {
      contact.delete().then(() => {
        Vue.delete(this.contacts, this.contacts.indexOf(contact))
      })
    },
    onDeleteConfirm () {
      this.deleteContact(this.itemToDelete)
      this.itemToDelete = null
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style lang="scss">
.group-field {
  padding: 20px;
}

.md-layout-item {
  padding: 10px;
}

.map {
  width: 100%;
  height:400px;
}

.md-select-menu.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default {
  @media(max-width: 960px) {
    left: 10px !important;
    max-width: calc(100% - 20px);
  }
  @media(min-width: 960px){
    max-width: 50%
  }
}
</style>
